import React, { useRef } from "react";
import { useEffect, useState } from "react";
import {
  CompanyManageGetAutoAvrageRate,
  CompanyManageGetAutoStock,
  CompanyManageMyCompany,
  CompanyManageMyStore,
  OfferPriceGetBaseData,
  OfferPriceSetPriceOffer,
} from "../../Api/Services";
import { toast } from "react-toastify";
import Zero from "../../assets/Icon/Zero.png";
import up from "../../assets/Icon/icons8-up-40.png";
import down from "../../assets/Icon/icons8-down-40.png";
import { useNavigate } from "react-router-dom";
import warning from "../../assets/Icon/icons8-warning-48.png";

function PriceOfferAE() {
  const [isLoading, setLoading] = useState(true);
  const [Company, setCompany] = useState([]);
  const [LstPrice, setLstPrice] = useState([]);
  const [Data, setData] = useState();
  const [DataSort, setDataSort] = useState([]);
  const [CompanyId, setCompanyId] = useState();
  const navigate = useNavigate();
  const [ActiveProd, SetActiveProd] = useState();
  const [Competitor, SetCompetitor] = useState([]);
  const inputRefs = useRef([]);
  const jalaali = require("jalaali-js");
  const [Package, SetPackage] = useState([]);

  const start = async () => {
    setCompany([]);
    setCompanyId();
    try {
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        for (const item of CompanyManageMyStoreData.data.data) {
          const CompanyManageGetAutoAvrageRateData =
            await CompanyManageGetAutoAvrageRate(item.companyStoreId);
          if (
            CompanyManageGetAutoAvrageRateData.status &&
            CompanyManageGetAutoAvrageRateData.status === 200
          ) {
            if (CompanyManageGetAutoAvrageRateData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای نرخ میانگین برقرار شد
                ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
          const CompanyManageGetAutoStockData = await CompanyManageGetAutoStock(
            item.companyStoreId,
          );
          if (
            CompanyManageGetAutoStockData.status &&
            CompanyManageGetAutoStockData.status === 200
          ) {
            if (CompanyManageGetAutoStockData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای موجودی برقرار شد
                ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
        }
      }

      const CompanyManageMyCompanysData = await CompanyManageMyCompany();
      if (
        CompanyManageMyCompanysData.status &&
        CompanyManageMyCompanysData.status === 200
      ) {
        setCompany(CompanyManageMyCompanysData.data.data);

        if (CompanyManageMyCompanysData.data.data.length > 0) {
          let id = CompanyManageMyCompanysData.data.data[0].companyId;
          setCompanyId(id);
          const OfferPriceGetBaseDataData = await OfferPriceGetBaseData(id);
          if (
            OfferPriceGetBaseDataData.status &&
            OfferPriceGetBaseDataData.status === 200
          ) {
            setData(OfferPriceGetBaseDataData.data.data);

            let modelSort = [];
            OfferPriceGetBaseDataData.data.data.getBaseData.forEach(
              (itempro) => {
                OfferPriceGetBaseDataData.data.data.allStore.forEach(
                  (itemStore) => {
                    if (
                      itempro.companyStoreStocks?.find(
                        (w) => w.companyStoreId == itemStore.companyStoreId,
                      )?.stock > 0
                    ) {
                      modelSort.push(
                        itempro.id + "-" + itemStore.companyStoreId,
                      );
                    }
                  },
                );
              },
            );
            setDataSort(modelSort);
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const groupProducts = (products) => {
    let copy = [...Data.getBaseData];
    let res = copy.filter(
      (w) =>
        w.productBerandId == products.productBerandId &&
        w.productTypeId == products.productTypeId &&
        w.productSeriesId == products.productSeriesId &&
        w.symbol == products.symbol &&
        w.productSeriesEndId == products.productSeriesEndId &&
        w.productRamId == products.productRamId &&
        w.productRomId == products.productRomId &&
        w.productNetworkId == products.productNetworkId &&
        w.isInsurance == products.isInsurance &&
        w.productCountryId == products.productCountryId,
    );

    return res;
  };

  const Add = async () => {
    setLoading(true);
    try {
      const OfferPriceSetPriceOfferData = await OfferPriceSetPriceOffer({
        Data: LstPrice.filter((w) => w.Price != ""),
      });
      if (
        OfferPriceSetPriceOfferData.status &&
        OfferPriceSetPriceOfferData.status === 200
      ) {
        toast.success(" اطلاعات  با موفقیت ثبت  شد");
        navigate("/Panel/PriceOffer");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      start();
    }
  };

  const SetCompany = async (id) => {
    setCompanyId(id);
    setLstPrice([]);
    setLoading(true);
    try {
      const OfferPriceGetBaseDataData = await OfferPriceGetBaseData(id);
      if (
        OfferPriceGetBaseDataData.status &&
        OfferPriceGetBaseDataData.status === 200
      ) {
        setData(OfferPriceGetBaseDataData.data.data);
        let modelSort = [];
        OfferPriceGetBaseDataData.data.data.getBaseData.forEach((itempro) => {
          OfferPriceGetBaseDataData.data.data.allStore.forEach((itemStore) => {
            if (
              itempro.companyStoreStocks?.find(
                (w) => w.companyStoreId == itemStore.companyStoreId,
              )?.stock > 0
            ) {
              modelSort.push(itempro.id + "-" + itemStore.companyStoreId);
            }
          });
        });
        setDataSort(modelSort);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeSearch = (productId, companyStoreId, e) => {
    const newForm = [...LstPrice];
    let item = newForm.find(
      (e) => e.ProductId == productId && e.CompanyStoreId == companyStoreId,
    );
    if (item) {
      item.Price = e.target.value.replaceAll(",", "");
    } else {
      newForm.push({
        ProductId: productId,
        CompanyStoreId: companyStoreId,
        Price: e.target.value.replaceAll(",", ""),
      });
    }
    setLstPrice(newForm);
  };

  const checkColor = (ProId, storeID, Avrager) => {
    var Pish = LstPrice.find(
      (e) => e.ProductId == ProId && e.CompanyStoreId == storeID,
    )?.Price;
    if (Pish && Avrager) {
      if (Pish < Avrager) {
        return "ghermez";
      }
      if (Pish > Avrager) {
        return "Sabz";
      }
      if (Pish == Avrager) {
        return "";
      }
    } else {
      return "Zard";
    }
  };

  const ChangeActive = (id) => {
    let copy = [...Competitor];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetCompetitor(copy);
  };

  const ChangeActivePackage = (id) => {
    let copy = [...Package];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetPackage(copy);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element">
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-1">
            <div className="d-flex justify-content-between align-items-center">
              {Company &&
                Company.map((item, key) => (
                  <button
                    onClick={() => {
                      SetCompany(item.companyId);
                    }}
                    className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                      CompanyId == item.companyId ? "bg-warning" : ""
                    }`}
                  >
                    {item.companyName}
                  </button>
                ))}
            </div>
            <div className="d-flex flex-column">
              {Data?.allCategory.map((itemCategory) => (
                <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                  <div className="d-flex align-items-center">
                    <span> {itemCategory.competitorCategoryName}</span>
                  </div>
                  <div className="d-flex justify-align-center align-item-center flex-wrap">
                    {itemCategory.competitorCategoryCompetitors.map((item) => (
                      <div
                        className={`border rounded m-2 p-2 pointer ${
                          Competitor.includes(item.id) ? "Actice" : "DeActice"
                        }`}
                        onClick={() => {
                          ChangeActive(item.id);
                        }}
                      >
                        {item.name}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              {Data?.allPackage.length > 0 && (
                <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                  <div className="d-flex align-items-center">
                    <span> سبد</span>
                  </div>
                  <div className="d-flex justify-align-center align-item-center flex-wrap">
                    {Data.allPackage.map((item) => (
                      <div
                        className={`border rounded m-2 p-2 pointer ${
                          Package.includes(item.id) ? "Actice" : "DeActice"
                        }`}
                        onClick={() => {
                          ChangeActivePackage(item.id);
                        }}
                      >
                        {item.competitorName}
                        {item.title != "" && "(" + item.title + ")"}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {CompanyId && (
              <div>
                <div className="d-flex justify-content-start align-items-center w-100 m-5">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                </div>
                {Data && (
                  <div className="d-flex justify-content-center align-items-center w-100 tableC">
                    <table className="table" style={{ lineHeight: "normal" }}>
                      <thead className="sticky-header">
                        <tr className="trTable">
                          <th rowSpan={2}>سیمبل کالای</th>
                          <th rowSpan={2}>رنگ</th>
                          {Data.allCategory.map((item, key) => (
                            <React.Fragment key={key}>
                              <th
                                colSpan={
                                  item.competitorCategoryCompetitors.filter(
                                    (w) => Competitor.includes(w.id),
                                  ).length + 1
                                }
                                className={`${item.competitorCategoryColor}`}
                              >
                                {item.competitorCategoryName}
                              </th>
                            </React.Fragment>
                          ))}
                          {Data.allPackage.length > 0 && (
                            <th colSpan={Package.length + 1}>سبد</th>
                          )}
                          <th rowSpan={2}>انبار</th>
                          <th rowSpan={2}>موجودی</th>
                          <th rowSpan={2}>نرخ میانگین</th>
                          <th rowSpan={2}>اخرین قیمت پیشنهادی</th>
                          <th rowSpan={2}>اخرین قیمت</th>
                          <th rowSpan={2}>قیمت</th>
                        </tr>
                        <tr>
                          {Data.allCategory.map((itemCategory, key) => (
                            <React.Fragment key={key}>
                              <th
                                className={`${itemCategory.competitorCategoryColor}`}
                              >
                                میانگین
                              </th>
                              {itemCategory.competitorCategoryCompetitors
                                .filter((e) => Competitor.includes(e.id))
                                .map((item) => (
                                  <th
                                    className={`${itemCategory.competitorCategoryColor} border border-1 border-black`}
                                    key={item.id}
                                  >
                                    <div className="tooltip-container">
                                      <span className="tooltip-target">
                                        {item.name}
                                      </span>
                                      <div className="tooltip-box p-3">
                                        <span>
                                          {(() => {
                                            const date = new Date(
                                              item.dateLastAuto.replace(
                                                "T",
                                                " ",
                                              ),
                                            );
                                            const jalaaliDate =
                                              jalaali.toJalaali(date);
                                            const year = jalaaliDate.jy;
                                            const month = jalaaliDate.jm
                                              .toString()
                                              .padStart(2, "0");
                                            const day = jalaaliDate.jd
                                              .toString()
                                              .padStart(2, "0");
                                            const hours = date
                                              .getHours()
                                              .toString()
                                              .padStart(2, "0");
                                            const minutes = date
                                              .getMinutes()
                                              .toString()
                                              .padStart(2, "0");
                                            const seconds = date
                                              .getSeconds()
                                              .toString()
                                              .padStart(2, "0");

                                            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                          })()}
                                        </span>
                                      </div>
                                    </div>
                                  </th>
                                ))}
                            </React.Fragment>
                          ))}
                          {Data.allPackage.length > 0 && (
                            <React.Fragment>
                              <th>میانگین</th>
                              {Data.allPackage
                                .filter((w) => Package.includes(w.id))
                                .map((item) => (
                                  <th
                                    className={`border border-1 border-black`}
                                    key={item.id}
                                  >
                                    <div className="tooltip-container">
                                      <span className="tooltip-target">
                                        {item.competitorName}
                                        {item.title != "" &&
                                          "(" + item.title + ")"}
                                      </span>
                                      <div className="tooltip-box p-3">
                                        <span>
                                          {item.createdDate &&
                                            (() => {
                                              const date = new Date(
                                                item.createdDate.replace(
                                                  "T",
                                                  " ",
                                                ),
                                              );
                                              const jalaaliDate =
                                                jalaali.toJalaali(date);
                                              const year = jalaaliDate.jy;
                                              const month = jalaaliDate.jm
                                                .toString()
                                                .padStart(2, "0");
                                              const day = jalaaliDate.jd
                                                .toString()
                                                .padStart(2, "0");
                                              const hours = date
                                                .getHours()
                                                .toString()
                                                .padStart(2, "0");
                                              const minutes = date
                                                .getMinutes()
                                                .toString()
                                                .padStart(2, "0");
                                              const seconds = date
                                                .getSeconds()
                                                .toString()
                                                .padStart(2, "0");

                                              return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                            })()}
                                        </span>
                                        <br></br>
                                        <span>{item.idAuto}</span>
                                      </div>
                                    </div>
                                  </th>
                                ))}
                            </React.Fragment>
                          )}
                        </tr>
                      </thead>

                      {Data.getBaseData.map((itemPro, keyPro) => (
                        <tbody
                          key={itemPro.id}
                          style={{
                            border: "2px solid black",
                          }}
                        >
                          <tr
                            className={`${
                              itemPro.id == ActiveProd && "bg-warning"
                            }`}
                            key={keyPro}
                          >
                            <td rowSpan={Data.allStore.length}>
                              {itemPro.productBerandName != " " &&
                                itemPro.productBerandName + " "}
                              {itemPro.productTypeName != " " &&
                                itemPro.productTypeName + " "}
                              {itemPro.productSeriesName != " " &&
                                itemPro.productSeriesName}
                              {itemPro.symbol}
                              {itemPro.productSeriesEndName != " "
                                ? itemPro.productSeriesEndName + " "
                                : " "}
                              {itemPro.productRamName != " " &&
                                itemPro.productRamName + "/"}
                              {itemPro.productRomName != " " &&
                                itemPro.productRomName + " "}
                              {itemPro.productNetworkName != " " &&
                                itemPro.productNetworkName + " "}
                              {itemPro.productCountryName != " " &&
                                itemPro.productCountryName + " "}
                              {itemPro.isInsurance && "بیمه"}
                            </td>
                            <td rowSpan={Data.allStore.length}>
                              <div className="d-flex justify-content-center align-item-center">
                                <div
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    backgroundColor: itemPro.productColorCode,
                                  }}
                                  className={`p-3 rounded-circle border border-3`}
                                ></div>
                              </div>
                              {itemPro.productColorName}
                            </td>
                            {Data.allCategory.map((itemCategory) => (
                              <>
                                <td
                                  rowSpan={Data.allStore.length}
                                  className={
                                    itemCategory.competitorCategoryColor
                                  }
                                >
                                  {(() => {
                                    const prices = itemPro.competitorPrices
                                      .filter((e) =>
                                        itemCategory.competitorCategoryCompetitors.some(
                                          (w) => w.id === e.competitorId,
                                        ),
                                      )
                                      .map((w) => w.price);

                                    if (prices.length === 0) return "-";

                                    return Math.floor(
                                      prices.reduce(
                                        (sum, value) => sum + value,
                                        0,
                                      ) / prices.length,
                                    )
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                  })()}
                                </td>

                                {itemCategory.competitorCategoryCompetitors
                                  .filter((e) => Competitor.includes(e.id))
                                  .map((itemCompetitore) => (
                                    <td
                                      rowSpan={Data.allStore.length}
                                      className={`${itemCategory.competitorCategoryColor}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-center">
                                        {(() => {
                                          const matchedPrice =
                                            itemPro.competitorPrices.find(
                                              (e) =>
                                                e.competitorId ===
                                                itemCompetitore.id,
                                            );
                                          const created =
                                            matchedPrice?.createdDate?.toString();

                                          const updated =
                                            itemCompetitore?.deletedDate?.toString();

                                          return (
                                            created !== updated &&
                                            itemPro.competitorPrices.find(
                                              (e) =>
                                                e.competitorId ==
                                                itemCompetitore.id,
                                            )?.price && (
                                              <img
                                                width="20px"
                                                height="20px"
                                                src={Zero}
                                              />
                                            )
                                          );
                                        })()}
                                        <span>
                                          {(() => {
                                            let price =
                                              itemPro.competitorPrices.find(
                                                (e) =>
                                                  e.competitorId ==
                                                  itemCompetitore.id,
                                              );
                                            if (price) {
                                              return price.price
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                );
                                            } else {
                                              return "-";
                                            }
                                          })()}
                                        </span>
                                        {(() => {
                                          let ascending = null;
                                          let Count = 0;
                                          let data =
                                            itemPro.competitorPrices.filter(
                                              (e) =>
                                                e.competitorId ==
                                                itemCompetitore.id,
                                            );

                                          if (data) {
                                            if (data.length > 1) {
                                              let lastAmount = data.shift();
                                              data.forEach((item) => {
                                                if (
                                                  item.price < lastAmount.price
                                                ) {
                                                  if (ascending == true) {
                                                    Count++;
                                                  } else {
                                                    Count = 1;
                                                    ascending = true;
                                                  }
                                                }
                                                if (
                                                  item.price > lastAmount.price
                                                ) {
                                                  if (ascending == false) {
                                                    Count++;
                                                  } else {
                                                    Count = 1;
                                                    ascending = false;
                                                  }
                                                }
                                              });
                                            }
                                          }
                                          if (ascending == true) {
                                            return (
                                              <>
                                                <span className="Sabz border rounded p-1 me-3">
                                                  {Count && Count}
                                                </span>
                                                <img
                                                  width={"20px"}
                                                  height={"20px"}
                                                  src={up}
                                                />
                                              </>
                                            );
                                          }
                                          if (ascending == false) {
                                            return (
                                              <>
                                                <span className="ghermez border rounded p-1 me-3">
                                                  {Count && Count}
                                                </span>
                                                <img
                                                  idth={"20px"}
                                                  height={"20px"}
                                                  src={down}
                                                />
                                              </>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </td>
                                  ))}
                              </>
                            ))}
                            {Data.allPackage.length > 0 && (
                              <React.Fragment>
                                <td rowSpan={Data.allStore.length}>
                                  {(() => {
                                    const average =
                                      groupProducts(
                                        itemPro,
                                      )[0].competitorPackagePrices.reduce(
                                        (sum, item) => sum + item.price,
                                        0,
                                      ) /
                                      groupProducts(itemPro)[0]
                                        .competitorPackagePrices.length;
                                    return average
                                      ? Math.floor(average)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "-";
                                  })()}
                                </td>

                                {Data.allPackage
                                  .filter((w) => Package.includes(w.id))
                                  .map((itemCompetitore) => (
                                    <td
                                      key={itemCompetitore.id}
                                      rowSpan={Data.allStore.length}
                                    >
                                      <div className="d-flex align-item-center justify-content-around">
                                        {(() => {
                                          const price = groupProducts(
                                            itemPro,
                                          )[0]?.competitorPackagePrices?.find(
                                            (e) =>
                                              e.competitorPackageId ==
                                              itemCompetitore.id,
                                          );
                                          return price?.price ? (
                                            <span>
                                              {price.price
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                )}
                                            </span>
                                          ) : (
                                            <span>-</span>
                                          );
                                        })()}
                                      </div>
                                    </td>
                                  ))}
                              </React.Fragment>
                            )}
                            <td>{Data.allStore[0].companyStoreName}</td>
                            <td>
                              {
                                itemPro.companyStoreStocks.find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore[0].companyStoreId,
                                )?.stock
                              }
                            </td>
                            <td>
                              {itemPro.companyStoreAverageRates
                                .find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore[0].companyStoreId,
                                )
                                ?.price.toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}

                              {itemPro.companyStoreAverageRates.find(
                                (w) =>
                                  w.companyStoreId ==
                                  Data.allStore[0].companyStoreId,
                              )?.isWarning && (
                                <img
                                  idth={"20px"}
                                  height={"20px"}
                                  src={warning}
                                />
                              )}
                            </td>

                            <td>
                              {itemPro.companyStoreOfferPrices
                                .find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore[0].companyStoreId,
                                )
                                ?.price.toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td>
                              {itemPro.companyStorePrices
                                .find(
                                  (w) =>
                                    w.companyStoreId ==
                                    Data.allStore[0].companyStoreId,
                                )
                                ?.price.toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td>
                              {itemPro.companyStoreStocks?.find(
                                (w) =>
                                  w.companyStoreId ==
                                  Data.allStore[0].companyStoreId,
                              )?.stock > 0 && (
                                <input
                                  onFocus={() => SetActiveProd(itemPro.id)}
                                  className={checkColor(
                                    itemPro.id,
                                    Data.allStore[0].companyStoreId,
                                    itemPro.companyStoreAverageRates.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        Data.allStore[0].companyStoreId,
                                    )?.price,
                                  )}
                                  id={
                                    itemPro.id +
                                    "-" +
                                    Data.allStore[0].companyStoreId
                                  }
                                  ref={(el) =>
                                    (inputRefs.current[
                                      itemPro.id +
                                        "-" +
                                        Data.allStore[0].companyStoreId
                                    ] = el)
                                  }
                                  onKeyDown={(e) => {
                                    const currentIndex = DataSort.findIndex(
                                      (item) => item == e.target.id,
                                    );
                                    if (
                                      e.key === "Enter" ||
                                      e.key === "ArrowDown"
                                    ) {
                                      e.preventDefault();
                                      const nextItem =
                                        DataSort[currentIndex + 1];
                                      if (nextItem) {
                                        inputRefs.current[nextItem]?.focus();

                                        setTimeout(() => {
                                          inputRefs.current[nextItem]?.select(); 
                                        }, 0);
                                      }
                                    } else if (e.key === "ArrowUp") {
                                      e.preventDefault();
                                      const prevItem =
                                        DataSort[currentIndex - 1];
                                      if (prevItem) {
                                        inputRefs.current[prevItem]?.focus();
                                        setTimeout(() => {
                                          inputRefs.current[prevItem]?.select(); 
                                        }, 0);
                                      }
                                    }
                                  }}
                                  value={LstPrice.find(
                                    (e) =>
                                      e.ProductId == itemPro.id &&
                                      e.CompanyStoreId ==
                                        Data.allStore[0].companyStoreId,
                                  )
                                    ?.Price.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  onChange={(e) => {
                                    handleChangeSearch(
                                      itemPro.id,
                                      Data.allStore[0].companyStoreId,
                                      e,
                                    );
                                  }}
                                />
                              )}
                            </td>
                          </tr>
                          {[...Data.allStore]
                            .slice(1)
                            .map((itemstore, index) => (
                              <tr
                                className={`${
                                  itemPro.id == ActiveProd && "bg-warning"
                                }`}
                              >
                                <td>{itemstore.companyStoreName}</td>
                                <td>
                                  {
                                    itemPro.companyStoreStocks.find(
                                      (w) =>
                                        w.companyStoreId ==
                                        itemstore.companyStoreId,
                                    )?.stock
                                  }
                                </td>
                                <td>
                                  {itemPro.companyStoreAverageRates
                                    .find(
                                      (w) =>
                                        w.companyStoreId ==
                                        itemstore.companyStoreId,
                                    )
                                    ?.price.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  {itemPro.companyStoreAverageRates.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      itemstore.companyStoreId,
                                  )?.isWarning && (
                                    <img
                                      idth={"20px"}
                                      height={"20px"}
                                      src={warning}
                                    />
                                  )}
                                </td>

                                <td>
                                  {itemPro.companyStoreOfferPrices
                                    .find(
                                      (w) =>
                                        w.companyStoreId ==
                                        itemstore.companyStoreId,
                                    )
                                    ?.price.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                <td>
                                  {itemPro.companyStorePrices
                                    .find(
                                      (w) =>
                                        w.companyStoreId ==
                                        itemstore.companyStoreId,
                                    )
                                    ?.price.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                <td>
                                  {itemPro.companyStoreStocks?.find(
                                    (w) =>
                                      w.companyStoreId ==
                                      itemstore.companyStoreId,
                                  )?.stock > 0 && (
                                    <input
                                      onFocus={() => SetActiveProd(itemPro.id)}
                                      className={checkColor(
                                        itemPro.id,
                                        itemstore.companyStoreId,
                                        itemPro.companyStoreAverageRates.find(
                                          (w) =>
                                            w.companyStoreId ==
                                            itemstore.companyStoreId,
                                        )?.price,
                                      )}
                                      id={
                                        itemPro.id +
                                        "-" +
                                        itemstore.companyStoreId
                                      }
                                      ref={(el) =>
                                        (inputRefs.current[
                                          itemPro.id +
                                            "-" +
                                            itemstore.companyStoreId
                                        ] = el)
                                      }
                                      onKeyDown={(e) => {
                                        const currentIndex = DataSort.findIndex(
                                          (item) => item == e.target.id,
                                        );
                                        if (
                                          e.key === "Enter" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                          const nextItem =
                                            DataSort[currentIndex + 1];
                                          if (nextItem) {
                                            inputRefs.current[
                                              nextItem
                                            ]?.focus();
                                            setTimeout(() => {
                                              inputRefs.current[
                                                nextItem
                                              ]?.select(); 
                                            }, 0);
                                          }
                                        } else if (e.key === "ArrowUp") {
                                          e.preventDefault();
                                          const prevItem =
                                            DataSort[currentIndex - 1];
                                          if (prevItem) {
                                            inputRefs.current[
                                              prevItem
                                            ]?.focus();
                                            setTimeout(() => {
                                              inputRefs.current[
                                                prevItem
                                              ]?.select(); 
                                            }, 0);
                                          }
                                        }
                                      }}
                                      value={LstPrice.find(
                                        (e) =>
                                          e.ProductId == itemPro.id &&
                                          e.CompanyStoreId ==
                                            itemstore.companyStoreId,
                                      )
                                        ?.Price.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                      onChange={(e) => {
                                        handleChangeSearch(
                                          itemPro.id,
                                          itemstore.companyStoreId,
                                          e,
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      ))}
                      {/* </tbody> */}
                    </table>
                  </div>
                )}
                <div className="d-flex justify-content-start align-items-center w-100 m-5">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default PriceOfferAE;
